import React from 'react';
import { isRoleAdmin, isUserCoffee } from 'src/utils/check-user-is-admin';
import Page403 from 'src/pages/403';

export default function AdminOrCoffeeGuard({ children }: { children: React.ReactNode }) {
  return isRoleAdmin() || isUserCoffee() ? <>{children}</> : <Page403 />;
}
